<template>
    <div v-if="showBulkAction" class="layout-bulk-action">
        <div class="selected-counter">
            <div class="mark">
                <img src="../../assets/images/check-icon-white.svg" alt="">
            </div>
            <span v-text="selectedCounterText"></span>
        </div>
        <div class="actions-group">
            <text-button label="merge" class="small" @click="actionMerge"/>
            <img src="../../assets/images/x-icon-white.svg" alt="X" @click="actionClose">
        </div>
        <merge-accounts-modal/>
    </div>
</template>

<script>
    import {mapGetters, mapMutations} from "vuex";
    import TextButton from "../components/TextButton";
    import MergeAccountsModal from "../modals/MergeAccountsModal";

    export default {
        name: "AccountUnificationBulkAction",
        components: {MergeAccountsModal, TextButton},
        computed: {
            selectedItemCounter() {
                return this.selectedItems.length;
            },
            selectedCounterText() {
                return this.selectedItemCounter + ' selected user(s)';
            },
            showBulkAction() {
                return this.selectedItemCounter > 0;
            },
            ...mapGetters('app', {
                selectedItems: 'getSelectedItems',
            })
        },
        methods: {
            actionMerge() {
                this.$modals.show(this.$enums.ModalNameEnum.MERGE_ACCOUNTS);
            },
            actionClose() {
                this.clearSelectedItems();
            },
            ...mapMutations('app', {
                clearSelectedItems: 'clearSelectedItems',
            })
        }
    }
</script>

<style lang="scss" scoped>
    @import "../scss/variables";

    .layout-bulk-action {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: fixed;
        left: 72px;
        bottom: 12px;
        width: calc(100% - 144px);
        height: 42px;
        padding: 0 24px;
        box-sizing: border-box;
        border-radius: $s-border-radius;
        background-color: $bg-color;
        color: $white-color;
        animation: show 200ms;

        .selected-counter {
            display: flex;
            align-items: center;

            .mark {
                width: 16px;
                height: 16px;
                border-radius: $s-border-radius;
                background-color: $main-color;
                cursor: pointer;

                & > img {
                    height: 100%;
                }
            }

            & > span {
                margin-left: 12px;
                font-weight: lighter;
                font-size: $m-font-size;
            }
        }

        .actions-group {
            display: flex;
            align-items: center;

            & > img {
                margin-left: 24px;
                height: 16px;
                cursor: pointer;
            }
        }
    }

    @keyframes show {
        from {
            bottom: -42px;
        }
        to {
            bottom: 12px;
        }
    }
</style>